var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagraminline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M23 17.088C23 20.353 20.274 23 16.911 23H7.09C3.726 23 1 20.353 1 17.088V6.912C1 3.647 3.726 1 7.089 1h9.822C20.274 1 23 3.647 23 6.912z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M16.998 12.001C16.938 14.761 14.76 17 12 17a5 5 0 0 1-5-4.999c0-2.76 2.24-5.08 5-4.999 3.361.098 5.059 2.248 4.998 4.999z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
}))));
export default SvgInstagraminline;